import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface UserDetail {
  id: string
  code?: string | number | undefined
  succeedTransaction: number
  discount_user: string | null
  uuid: string
  blocked: boolean
  blocked_at: string | null
  country: {
    id: string
    title?: { fa?: string }
    iso?: string
    flagUrl?: string
  }
  countryCode: string
  credit: number
  document: {
    id: number
    user_id: number
    national_code: string
    status: string
  }
  email: string
  fullName: string
  identifications: Record<string, unknown>
  invitedUsers: Array<unknown>
  inviter: { id: number | null; name: string | null }
  isUserOld: number
  mobile: string
  msisdn: string
  national_code: string
  referralLink: string | null
  referralType: string
  shortReferralCode: string
  shortReferralLink: string
  statistics: {
    requisitions: number
    receivedOffers: number
    sentOffers: number
    inProgressTransactions: number
  }
  status: string
  updatedAt: string
  createdAt: string
}

export function getUserDetailAction(userUuid: string): Promise<ApiResponse<UserDetail>> {
  return api.get<ApiResponse<UserDetail>>(`/users/${userUuid}`)
}
